// extracted by mini-css-extract-plugin
module.exports = {"container":"PageNotFound_container__34XSJ","pageNotFound":"PageNotFound_pageNotFound__3sB-6"};